<h3>DANGER only use in emergencies DANGER</h3>
<h2 mat-dialog-title>Confirm Smart DX Clean Restart for {{data.env}} in {{data.region.display}}</h2>
<div mat-dialog-content>
  <table>
    <tr>
      <td>Jira ID</td>
      <td><input class="dialog-form-field" matInput [(ngModel)]="data.jiraId" placeholder="Enter ID..." required></td>
    </tr>
    <tr>
      <td>Jira Description</td>
      <td><textarea class="dialog-form-field" matInput [(ngModel)]="data.jiraDescription"
                    placeholder="Enter description..." maxlength="128" mat-autosize required></textarea></td>
    </tr>
  </table>
</div>

<div mat-dialog-actions>
  <button (click)="cancel()" mat-button>Cancel</button>
  <button mat-button [mat-dialog-close]="data">OK</button>
</div>
